<div *ngIf="data">
  <div class="row" style="border-bottom: 2px solid #ccc; margin-bottom: 7px">
    <div class="col-sm-11 movable">
      <h3
        class="head"
        cdkDrag
        cdkDragHandle
        cdkDragRootElement=".cdk-overlay-pane"
      >
        {{ data.mode | uppercase }} GROUP
      </h3>
    </div>

    <div class="col-sm-1">
      <button
        type="button"
        class="btn btn-dark btn-circle btn-xl"
        [mat-dialog-close]="true"
        data-dismiss="modal"
        aria-label="Close"
      >
        <span aria-hidden="true">×</span>
      </button>
    </div>
  </div>
  <form [formGroup]="addOrEditform">
    <div class="successMessage alert-dismissible">
      <div *ngIf="warningMessage" class="alert alert-warning" role="alert">
        {{ warningMessage }}
        <button
          type="button"
          class="btn-close"
          (click)="removeMessage()"
          data-bs-dismiss="alert"
          aria-label="Close"
        ></button>
      </div>
  
      <div *ngIf="successMessage" class="alert alert-success" role="alert">
      {{ successMessage }}
      <button
        type="button"
        class="btn-close"
        (click)="removeMessage()"
        data-bs-dismiss="alert"
        aria-label="Close"
      ></button>
      </div>
    </div>
    <div class="row">
      <div class="col-md-6">
        <div class="drpchildctrl">
          <span class="v1"></span>
          <label required class="searchLable">GROUP NAME</label>
          <input
          formControlName="groupName"
          class="key"
          type="text"
          placeholder="--Type--"
          />
          <ng-container *ngIf="addOrEdit.groupName.errors && submitted">
            <small *ngIf="addOrEdit.groupName.errors?.required">
              Group Name is required.
            </small>
          </ng-container>
        </div>
        <!-- readonly -->
      </div>
    </div>
    <br>
    <div class="row">

      <div class="col-md-6">
        <div class="drpchildctrl">
          <span class="v1"></span>
          <label class="searchLable">COUNT CYCLE</label>
          <input
          formControlName="countCycle"
          class="key"
          type="text"
          placeholder="--Type--"
          maxlength="3"
          (input)="onInput($event)"
          />
          <ng-container *ngIf="addOrEdit.countCycle.errors && submitted">
            <small *ngIf="addOrEdit.countCycle.errors?.required">
              Count Cycle is required.
            </small>
          </ng-container>
        </div>
      </div>
      <!-- <div  class="col-md-12" style=" margin-bottom: 5px; margin-top: 5px;">
        <div class="drpchildctrl">
          <label required class="searchLable" style="font-size: 15px;">ASSIGN PARTS TO GROUP</label>
        </div>
      </div>
      <div class="col-md-6">
        <div class="drpchildctrl">
          <label required class="searchLable">PART NO</label>

          <p-dropdown
            id="selSupplier"
            [filter]="true"
            [options]="data.partNumber"
            [virtualScroll]="true" 
            [itemSize]="25"
            [showTransitionOptions]="'0ms'" 
            placeholder="Select" 
            formControlName="partNo"
            optionLabel="item_id" 
            optionValue="item_id"
            [resetFilterOnHide]="true"
            (onChange)="onPartNoChange()"
            [hideTransitionOptions]="'0ms'" 
            autoWidth="true" 
            [style]="{ width: '100%' }"
            filterBy="item_id"
            scrollHeight="180px">
          >
          </p-dropdown>
          <ng-container *ngIf="addOrEdit.partNo.errors && submitted">
            <small *ngIf="addOrEdit.partNo.errors?.required">
              Part No is required.
            </small>
          </ng-container>
        </div>
      </div>
      <div class="col-md-6">
        <div class="drpchildctrl">
          <label required class="searchLable">KANBAN</label>

          <p-dropdown
            id="selSupplier"
            [filter]="true"
            [options]="data.kanbanNumber"
            [virtualScroll]="true" 
            [itemSize]="25"
            [showTransitionOptions]="'0ms'" 
            placeholder="Select" 
            formControlName="kanbanNo"
            optionLabel="kanban" 
            optionValue="kanban"
            [resetFilterOnHide]="true"
            [hideTransitionOptions]="'0ms'" 
            autoWidth="true" 
            (onChange)="onKanbanChange()"
            [style]="{ width: '100%' }"
            filterBy="kanban"
            scrollHeight="180px">
          >
          </p-dropdown>
          <ng-container *ngIf="addOrEdit.kanbanNo.errors && submitted">
            <small *ngIf="addOrEdit.kanbanNo.errors?.required">
              Kanban is required.
            </small>
          </ng-container>
        </div>
      </div> -->
    </div>

    <ng-container *ngIf="errorMessage1">
      <p style="color: red ;">{{ errorMessage1 }}</p>
    </ng-container>
  </form>
 
  <!-- <div class="text-right" style="margin-top: 15px">
    <button class="review_btn" mat-button (click)="callRespectiveFunction('add')">
      Add
    </button>

    <button class="cancel_btn" mat-button mat-dialog-close="cancel">
      Cancel
    </button>
  </div>
  <br><br>
  <div class="col-md-12">
    <ag-grid-angular #osPartsGrid style="
        width: 100%;
        margin-top: 35px;
        height: 150px !important;
        top: 3%;
        margin-bottom: 2%;
      " class="ag-theme-balham table-outer" [rowData]="rowData" [columnDefs]="columnDefs" [rowSelection]="rowSelection"
      [gridOptions]="gridOptions" [context]="context" [editType]="editType" [suppressClickEdit]="suppressClickEdit"
       [suppressClickEdit]="true" >
    </ag-grid-angular>
  
  </div> -->
  <br>
  <div class="text-right" style="margin-top: 15px">
    <!-- <button class="review_btn" mat-button > -->
      <button class="review_btn" mat-button (click)="editGroups('save')">
      Save
    </button>

    <button class="cancel_btn" mat-button mat-dialog-close="cancel">
      Cancel
    </button>
  </div>
</div>
<ngx-spinner bdColor="rgba(51,51,51,0.8)" size="medium" color="#fff" type="ball-scale-multiple">
  <p style="font-size: 20px; color: white">Loading... Please wait...</p>
</ngx-spinner>
